import React from 'react';
import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { colors } from 'utils/styles/theme';

// Year is computed at render; static HTML carries the build year and the browser
// corrects it to the current year on hydration, so it auto-updates each year.
const Wrapper = styled.span`
  ${setTypography('linkSmall')};
  color: ${colors.white};
  white-space: nowrap;
`;

const Copyright: React.FC = () => (
  <Wrapper suppressHydrationWarning>© {new Date().getFullYear()} Human</Wrapper>
);

export default Copyright;
